import { useEffect, useState } from "react";
import { enumUtil } from "../../../utils/Enum";
import { GetZipCode, ServerRequestProtected } from "../../../utils/ServerDataRequest"
import DropdownValueHandler from "../../shared/SuperSearch/DropdownValueHandler";
import FormatPhoneNumber from "../../../utils/FormatPhoneNumber";
import Loader from "../../shared/Loader/Loader";
import isNull from "../../../utils/NullChecking";
import States, { EmploymentStatus, GenderDemographic, GenderIdentity, MaritalStatus, PreferredLanguage } from "../../../utils/Constants";
import handleAlphabeticCheck from "../../../utils/HandleAlphabetKeys";
import NotificationHandler from "../../../utils/NotificationHandler";
import SuperSearchList from "../../shared/SuperSearch/SuperSearchList";
import DatePicker from "../DatePicker";
import handleNumericCheck from "../../../utils/HandleNumericKeys";
import LogoRef from '../../../assets/img/logoRef.png';
import { formatFax } from "../../../utils/Formatting";
const Races = [
    {
        value: 'American Indian or Alaska Native', display: 'American Indian or Alaska Native',
        SubCategories: [
            { value: "Navajo Nation", display: 'Navajo Nation' },
            { value: "Cherokee", display: 'Cherokee' },
            { value: "Sioux", display: 'Sioux' },
            { value: "Chippewa", display: 'Chippewa' },
            { value: "Cherokee", display: 'Cherokee' },
            { value: "Apache", display: 'Apache' },
            { value: "Blackfeet", display: 'Blackfeet' },
            { value: "Iñupiat", display: 'Iñupiat' },
            { value: "Yup'ik", display: "Yup'ik" },
            { value: "Central American Indian", display: 'Central American Indian' },
            { value: "South American Indian", display: 'South American Indian' },
            { value: "Other American Indian tribes", display: 'Other American Indian tribes' },
        ]
    },
    {
        value: 'Asian', display: 'Asian',
        SubCategories: [
            { value: "Chinese", display: 'Chinese' },
            { value: "Filipino", display: 'Filipino' },
            { value: "Asian Indian", display: 'Asian Indian' },
            { value: "Vietnamese", display: 'Vietnamese' },
            { value: "Korean", display: 'Korean' },
            { value: "Japanese", display: 'Japanese' },
            { value: "Pakistani", display: 'Pakistani' },
            { value: "Thai", display: "Thai" },
            { value: "Cambodian", display: "Cambodian" },
            { value: "Hmong", display: "Hmong" },
            { value: "Laotian", display: "Laotian" },
            { value: "Other Asian", display: "Other Asian" },
        ]
    },
    {
        value: 'Black or African American', display: 'Black or African American',
        SubCategories: [
            { value: "African American", display: 'African American' },
            { value: "Jamaican", display: 'Jamaican' },
            { value: "Haitian", display: 'Haitian' },
            { value: "Nigerian", display: 'Nigerian' },
            { value: "Ethiopian", display: 'Ethiopian' },
            { value: "Somali", display: 'Somali' },
            { value: "Other African", display: 'Other African' },
            { value: "Afro-Caribbean", display: "Afro-Caribbean" },
        ]
    },
    {
        value: 'Native Hawaiian or Other Pacific Islander', display: 'Native Hawaiian or Other Pacific Islander',
        SubCategories: [
            { value: "Native Hawaiian", display: 'Native Hawaiian' },
            { value: "Samoan", display: 'Samoan' },
            { value: "Chamorro", display: 'Chamorro' },
            { value: "Tongan", display: 'Tongan' },
            { value: "Fijian", display: 'Fijian' },
            { value: "Marshallese", display: 'Marshallese' },
            { value: "Palauan", display: 'Palauan' },
            { value: "Tahitian", display: 'Tahitian' },
            { value: "Chuukese", display: 'Chuukese' },
            { value: "Other Pacific Islander", display: 'Other Pacific Islander' },

        ]
    },
    {
        value: 'White', display: 'White',
        SubCategories: [
            { value: "German", display: 'German' },
            { value: "Irish", display: 'Irish' },
            { value: "English", display: 'English' },
            { value: "Italian", display: 'Italian' },
            { value: "Polish", display: 'Polish' },
            { value: "French", display: 'French' },
            { value: "Iranian", display: 'Iranian' },
            { value: "Arab", display: 'Arab' },
            { value: "Other European", display: 'Other European' },
            { value: "Other Middle Eastern", display: 'Other Middle Eastern' },
            { value: "Other North African", display: 'Other North African' },

        ]
    },
    { value: 'Other', display: 'Other' },
    { value: 'Unknown', display: 'Unknown' },
    { value: 'Patient declines to specify', display: 'Patient declines to specify' },
];
const Ethnicity = [
    {
        value: 'Hispanic or Latino', display: 'Hispanic or Latino',
        SubCategories: [
            { value: "Mexican", display: 'Mexican' },
            { value: "Puerto Rican", display: 'Puerto Rican' },
            { value: "Cuban", display: 'Cuban' },
            { value: "Dominican", display: 'Dominican' },
            { value: "Salvadoran", display: 'Salvadoran' },
            { value: "Guatemalan", display: 'Guatemalan' },
            { value: "Colombian", display: 'Colombian' },
            { value: "Honduran", display: 'Honduran' },
            { value: "Ecuadorian", display: "Ecuadorian" },
            { value: "Peruvian", display: "Peruvian" },
            { value: "Venezuelan", display: "Venezuelan" },
            { value: "Panamanian", display: "Panamanian" },
            { value: "Nicaraguan", display: "Nicaraguan" },
            { value: "Chilean", display: "Chilean" },
            { value: "Argentine", display: "Argentine" },
            { value: "Other Central American", display: "Other Central American" },
            { value: "Other South American", display: "Other South American" },
            { value: "Other Hispanic or Latino", display: "Other Hispanic or Latino" },

        ]


    },
    { value: 'Not Hispanic or Latino', display: 'Not Hispanic or Latino' },
    { value: 'Other', display: 'Other' },
    { value: 'Unknown', display: 'Unknown' },
    { value: 'Patient declines to specify', display: 'Patient declines to specify' },

]
const FillPatientDemographicsForm = ({ ID, PracticeInfo, IsSubmitted, isDeleted }) => {
    // Define the complete form modal matching API structure
    let Demographics_Modal = {
        PatientIntakeFormID: "",
        FirstName: "",
        MiddleName: "",
        LastName: "",
        PreferredName: "",
        SSN: "",
        DOB: "",
        Address1: "",
        Address2: "",
        ZipCode: "",
        City: "",
        State: "",
        CellPhone: "",
        HomePhone: "",
        WorkPhone: "",
        OtherPhone: "",
        Sex: "",
        GenderIdentity: "",
        Race: "",
        Ethnicity: "",
        MaritalStatus: "",
        EmploymentStatus: "",
        PreferredLanguage: "",
        OTP: "",
    }
    // Validation state
    const [validationErrors, setValidationErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const API_URL = enumUtil.controller.PatientPortal
    const API_URL_Intake = enumUtil.controller.PATIENT
    const [patientFormData, setPatientFormData] = useState(Demographics_Modal)
    const [savePatientFormData, setSavePatientFormData] = useState({})
    const [isFormSubmitted, setIsFormSubmitted] = useState(IsSubmitted === "true" ? true : false);
    const [isFormSaved, setIsFormSaved] = useState(false);
    const [is, setIs] = useState(true);
    // Validation functions
    const validateField = (name, value) => {
        let error = "";
        switch (name) {
            case 'LastName':
            case 'FirstName':
                if (!value || value.trim() === '') {
                    error = "First Name is required";
                }
                break;
            case 'SSN':
                if (!isNull(value) && !/^\d{9}$/.test(value.replace(/\D/g, ''))) {
                    error = "SSN length should be 9 digits";
                }
                //     if (!value || value.trim() === '') {
                //         error = "SSN is required";
                //     }
                break;
            case 'DOB':
                if (!value || value.trim() === '') {
                    error = "Date of birth is required";
                }
                break;
            case 'Address1':
                if (!value || value.trim() === '') {
                    error = "Address is required";
                }
                break;
            case 'ZipCode':
                if (!value || value.trim() === '') {
                    error = "ZIP code is required";
                }
                break;
            case 'City':
                if (!value || value.trim() === '') {
                    error = "City is required";
                }
                break;
            case 'State':
                if (!value || value === '') {
                    error = "State is required";
                }
                break;
            case 'CellPhone':
                // if (!value || value.trim() === '') {
                //     error = "Cell phone is required";
                // }
                //  else
                if (value && value.trim() !== '' && !/^\d{10}$/.test(value.replace(/\D/g, ''))) {
                    error = "Cell phone number should be 10 digits";
                }
                break;
            case 'HomePhone':
                if (value && value.trim() !== '' && !/^\d{10}$/.test(value.replace(/\D/g, ''))) {
                    error = "Home phone number should be 10 digits";
                }
                break;
            case 'WorkPhone':
                if (value && value.trim() !== '' && !/^\d{10}$/.test(value.replace(/\D/g, ''))) {
                    error = "Work phone number should be 10 digits";
                }
                break;
            case 'OtherPhone':
                if (value && value.trim() !== '' && !/^\d{10}$/.test(value.replace(/\D/g, ''))) {
                    error = "Other phone number should be 10 digits";
                }
                break;
            case 'Sex':
                if (!value || value.trim() === '') {
                    error = "Sex is required";
                }
            case 'OTP':
                if (!value || value.trim() === '') {
                    error = "OTP is required";
                }
                break;
                break;
        }
        return error;
    }
    const validateForm = () => {
        const errors = {};
        const requiredFields = ['LastName', 'FirstName', 'SSN', 'DOB', 'Address1', 'ZipCode', 'City', 'State', 'CellPhone', 'Sex', 'HomePhone', 'WorkPhone', 'OtherPhone', 'OTP'];
        requiredFields.forEach(field => {
            const error = validateField(field, patientFormData[field]);
            if (error) {
                errors[field] = error;
            }
        });
        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    }
    const handleSubmitForm = () => {
        if (!validateForm()) {
            NotificationHandler("Please fill all required fields correctly", enumUtil.enumtoaster.error);
            return;
        }
        setIsLoading(true)
        // Prepare data for API - only include fields that exist in Demographics_Modal
        const saveData = {
            TableName: enumUtil.enumAPITableName.PatientIntakeTemplateData,
            ID: 0, // For new records, 0 for create
            DATA: { ...savePatientFormData, PatientIntakeFormID: '0', GuidID: ID, PatientID: savePatientFormData.PatientID + "" }
        }
        ServerRequestProtected(API_URL_Intake + "/SavePatientDemographics", 'post', saveData)
            .then((response) => {
                setIsFormSubmitted(true);
                setIsFormSaved(true);
                setIsLoading(false)
                NotificationHandler("Form submitted successfully", enumUtil.enumtoaster.success)
            }).catch((error) => {
                setIsLoading(false)
                setIsFormSubmitted(false);
                setIsFormSaved(false);
                NotificationHandler(error.response?.data || "Error submitting form", enumUtil.enumtoaster.error)
            })
    }
    const handleChangeDD = (e) => {
        setIs(false)
        let { name, value } = e.target;
        let modal = { ...patientFormData };
        modal[name] = value
        setPatientFormData(modal)

        // Clear validation error when field is changed
        if (validationErrors[name]) {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    }
    const handleChangeField = (e) => {
        let { name, value } = e.target;
        let modal = { ...patientFormData };
        let saveModal = { ...savePatientFormData }
        if (['CellPhone', 'HomePhone', 'WorkPhone', 'OtherPhone'].includes(name)) {
            const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            modal[name] = !formattedValue[2] ? formattedValue[1] : `(${formattedValue[1]}) ${formattedValue[2]}${formattedValue[3] ? '-' + formattedValue[3] : ''}`;
        } else if (name === 'ZipCode') {
            modal[name] = value;
            if (value.length === 9 || value.length === 5) {
                const firstFive = value.substring(0, 5);
                GetZipCode(firstFive)
                    .then(data => {
                        setPatientFormData(prevState => ({ ...prevState, ...data?.main }));
                        setSavePatientFormData(prevState => ({ ...prevState, ...data?.save }));
                    })
                    .catch(error => {
                        console.error("Zip code fetch error:", error);
                    });
            }
        } else {
            modal[name] = value;
        }
        setPatientFormData(modal)
        for (var property in Demographics_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setSavePatientFormData(saveModal)

        // Clear validation error when field is changed
        if (validationErrors[name]) {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    }
    const handleCalendarChange = (date, type) => {
        var FormatedDate = date
        setSavePatientFormData({ ...savePatientFormData, DOB: FormatedDate })
        setPatientFormData({ ...patientFormData, DOB: FormatedDate })
    }
    const handleSelectedData = (selectedData, name, type) => {
        setIs(true)
        let modal = { ...patientFormData };
        let saveModal = { ...savePatientFormData }

        if (type === 'client' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            saveModal[name] = selectedData.value + ""
        } else if (type === 'server' && !isNull(selectedData)) {
            modal[name] = selectedData.display
            saveModal[name] = selectedData.value + ""
        } else {
            modal[name] = ''
            saveModal[name] = ''
        }

        setPatientFormData(modal)
        setSavePatientFormData(saveModal)

        // Clear validation error when dropdown is selected
        if (validationErrors[name]) {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }

        return selectedData
    }
    const clearForm = () => {
        const clearedData = {
            ...Demographics_Modal,
            PatientIntakeFormID: '0'
        }
        setPatientFormData(clearedData)
        setSavePatientFormData(clearedData)
        setValidationErrors({}) // Clear validation errors
    }

    useEffect(() => {
        if (isDeleted === 'true') {
            NotificationHandler("This form has been deleted.", enumUtil.enumtoaster.error);
            return
        }
        ServerRequestProtected(API_URL_Intake + "/PatientData", 'post', {
            'TableName': enumUtil.enumAPITableName.PatientIntakeTemplateData,
            "Value": ID
        }).then((response) => {
            setIsLoading(false)
            setSavePatientFormData(response)
            let data = { ...response }
            data.State = DropdownValueHandler(States, response.State)
            data.Sex = DropdownValueHandler(GenderDemographic, response.Sex)
            data.GenderIdentity = DropdownValueHandler(GenderIdentity, response.GenderIdentity)
            data.MaritalStatus = DropdownValueHandler(MaritalStatus, response.MaritalStatus)
            data.EmploymentStatus = DropdownValueHandler(EmploymentStatus, response.EmploymentStatus)
            if (!isNull(data.CellPhone)) {
                data.CellPhone = FormatPhoneNumber(data.CellPhone)
            }
            if (!isNull(data.HomePhone)) {
                data.HomePhone = FormatPhoneNumber(data.HomePhone)
            }
            if (!isNull(data.WorkPhone)) {
                data.WorkPhone = FormatPhoneNumber(data.WorkPhone)
            }
            if (!isNull(data.OtherPhone)) {
                data.OtherPhone = FormatPhoneNumber(data.OtherPhone)
            }
            const mappedData = {
                ...Demographics_Modal,
                ...data,
            }
            setPatientFormData(mappedData)
        }).catch((error) => {
            setIsLoading(false)
            const initialData = {
                ...Demographics_Modal,
            }
            setPatientFormData(initialData)
            setSavePatientFormData(initialData)
        })
    }, [])
    return (
        <>
            {isDeleted === 'true' ? null :
                <div className='ar_pat-info-form-fill d-flex justify-content-center'>
                    {isLoading ? <Loader /> : null}
                    {isFormSubmitted ?
                            <div className="ar_fill-content-box d-flex flex-column">
                                <div className="d-flex align-items-center justify-content-between bg-white br-bottom-1 za_br_light pb-1-5 practice-info">
                                    <div className="">
                                        <img src={LogoRef} alt="" style={{ maxHeight: '55px' }} crossOrigin="anonymous" />
                                    </div>
                                    <div className="text-center">
                                        <p className='heading text-black fs-16'>{PracticeInfo?.PracticeName}</p>

                                        <p className="text text-black fs-14"> {PracticeInfo?.PracticeAddress} <br />
                                            {PracticeInfo?.PracticeCity} ,  {PracticeInfo?.PracticeState},  {PracticeInfo?.PracticeZipCode}</p>

                                    </div>
                                    <div className="d-flex gap-10">
                                        <div className="">
                                            <p className='text text-black font-m fs-14 pb-2px'>Tel:</p>
                                            <p className='text text-black font-m fs-14'>Fax:</p>
                                        </div>
                                        <div className="">
                                            <p className='text text-black  pb-2px fs-14'>{FormatPhoneNumber(PracticeInfo?.PracticeTelephone)}</p>
                                            {/* <p className='text text-black fs-14'>{PracticeInfo?.PracticeFax}</p> */}
                                            <p className='text text-black fs-14'>{formatFax(PracticeInfo?.PracticeFax)}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-white">
                                    <p className="heading fs-16 lh-17 text-white form-heading">Patient Demographics</p>
                                    {/* <p className="text fs-12 lh-14 form-instruction p-2">Please fill out all fields as accurately as possible. This information helps us provide you with the best care. If you need any assistance with completing this form, please don't hesitate to contact us.</p> */}
                                </div>
                                <div className='sucsses_meessage d-flex align-items-center gap-20'>
                                    <div>
                                        <i className='icon-tick-mark fs-49'></i>
                                    </div>
                                    <div >
                                        <p className='fs-22 text font-m green_Color'>
                                            {isFormSaved ? 'Form Submission Successful!' : 'This form is already submitted!'}
                                        </p>
                                        <p className='text fs-14'>Thank you for submitting the form. If you need further assistance, feel free to contact us.</p>
                                    </div>
                                </div>
                            </div>
                        :
                        <>
                            {/* <div className="ar_fill-content-box">
                        <div className="bg-white">
                            <div className="flex items-center justify-between form-heading">
                                <p className="heading fs-16 lh-17 text-white">Patient Information Form</p>
                            </div>
                            <p className="text fs-16 leading-5 form-instruction p-2">Please fill out all fields as accurately as possible. This information helps us provide you with the best care. If you need any assistance with completing this form, please don't hesitate to contact us.</p>
                        </div>
                        <div className="Form-content flex flex-col gap-4 pe-1 hover-scrollbar">
                            <div className="flex flex-col gap-4 content-box">
                                <div className="flex gap-10 items-center Name-Error">
                                    <p className='text fs-16 leading-5 min-w-[151px] flex items-center justify-end gap-0.5'>
                                        Name<span className="text font-m Denied-clr fs-14">*</span>
                                    </p>
                                    <div className="flex items-center gap-1.5">
                                        <div className='input'>
                                            <input type="text"
                                                className={`form-control ${validationErrors.LastName ? 'is-invalid' : ''}`}
                                                name="LastName"
                                                id="LastName"
                                                autoComplete="off"
                                                placeholder="Last"
                                                onChange={handleChangeField}
                                                value={patientFormData.LastName || ''}
                                                onKeyPress={handleAlphabeticCheck}
                                                maxLength={35}

                                            />
                                            {validationErrors.LastName && <div className="invalid-feedback">{validationErrors.LastName}</div>}
                                        </div>
                                        <div className='input'>
                                            <input type="text"
                                                className={`form-control ${validationErrors.FirstName ? 'is-invalid' : ''}`}
                                                name="FirstName"
                                                id="FirstName"
                                                autoComplete="off"
                                                placeholder="First"
                                                onChange={handleChangeField}
                                                value={patientFormData.FirstName || ''}
                                                onKeyPress={handleAlphabeticCheck}
                                                maxLength={35}

                                            />
                                            {validationErrors.FirstName && <div className="invalid-feedback">{validationErrors.FirstName}</div>}
                                        </div>
                                        <div className='input'>
                                            <input type="text"
                                                className='form-control'
                                                name="MiddleName"
                                                id="MiddleName"
                                                autoComplete="off"
                                                placeholder="Middle"
                                                onChange={handleChangeField}
                                                value={patientFormData.MiddleName || ''}
                                                onKeyPress={handleAlphabeticCheck}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] text-end'>Preferred Name</p>
                                    <div className='input w-full'>
                                        <input type="text"
                                            className='form-control'
                                            name="PreferredName"
                                            id="PreferredName"
                                            autoComplete="off"
                                            onChange={handleChangeField}
                                            value={patientFormData.PreferredName || ''}
                                            onKeyPress={handleAlphabeticCheck}
                                            maxLength={35}
                                        />
                                    </div>
                                </div>
                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] flex items-center justify-end gap-0.5'>
                                        SSN
                                    </p>
                                    <div className='input w-full'>
                                        <input type="text"
                                            className={`form-control ${validationErrors.SSN ? 'is-invalid' : ''}`}
                                            name="SSN"
                                            id="SSN"
                                            autoComplete="off"
                                            onChange={handleChangeField}
                                            value={patientFormData.SSN || ''}
                                            onKeyPress={(event) => handleNumericCheck(event)}
                                            maxLength={9}
                                        />
                                        {validationErrors.SSN && <div className="invalid-feedback">{validationErrors.SSN}</div>}
                                    </div>
                                </div>
                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] flex items-center justify-end gap-0.5'>
                                        Date of Birth<span className="text font-m Denied-clr fs-14">*</span>
                                    </p>
                                    <div className='input w-full'>
                                        <DatePicker
                                            value={patientFormData.DOB}
                                            handleCalendarChangefunc={date => handleCalendarChange(date, 'DOB')}
                                        />
                                        {validationErrors.DOB && <div className="invalid-feedback">{validationErrors.DOB}</div>}
                                    </div>
                                </div>
                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] flex items-center justify-end gap-0.5'>
                                        Address 1<span className="text font-m Denied-clr fs-14">*</span>
                                    </p>
                                    <div className='input w-full'>
                                        <input type="text"
                                            className={`form-control ${validationErrors.Address1 ? 'is-invalid' : ''}`}
                                            name="Address1"
                                            id="Address1"
                                            autoComplete="off"
                                            onChange={handleChangeField}
                                            value={patientFormData.Address1 || ''}
                                        />
                                        {validationErrors.Address1 && <div className="invalid-feedback">{validationErrors.Address1}</div>}
                                    </div>
                                </div>
                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] flex items-center justify-end gap-0.5'>
                                        Address 2
                                    </p>
                                    <div className='input w-full'>
                                        <input type="text"
                                            className='form-control'
                                            name="Address2"
                                            id="Address2"
                                            autoComplete="off"
                                            onChange={handleChangeField}
                                            value={patientFormData.Address2 || ''}
                                        />
                                    </div>
                                </div>
                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] flex items-center justify-end gap-0.5'>
                                        ZIP Code<span className="text font-m Denied-clr fs-14">*</span>
                                    </p>
                                    <div className='input w-full'>
                                        <input type="text"
                                            className={`form-control ${validationErrors.ZipCode ? 'is-invalid' : ''}`}
                                            name="ZipCode"
                                            id="ZipCode"
                                            autoComplete="off"
                                            onChange={handleChangeField}
                                            onKeyPress={(event) => handleNumericCheck(event)}
                                            value={patientFormData.ZipCode || ''}
                                            maxLength={9}
                                        />
                                        {validationErrors.ZipCode && <div className="invalid-feedback">{validationErrors.ZipCode}</div>}
                                    </div>
                                </div>
                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] flex items-center justify-end gap-0.5'>
                                        City/State<span className="text font-m Denied-clr fs-14">*</span>
                                    </p>
                                    <div className="flex align-items-center gap-1.5">
                                        <div className='input w-full'>
                                            <input type="text"
                                                className={`form-control ${validationErrors.City ? 'is-invalid' : ''}`}
                                                name="City"
                                                id="City"
                                                autoComplete="off"
                                                placeholder="City"
                                                onChange={handleChangeField}
                                                value={patientFormData.City || ''}
                                                maxLength={30}
                                            />
                                            {validationErrors.City && <div className="invalid-feedback">{validationErrors.City}</div>}
                                        </div>
                                        <div className='input w-full'>
                                            <SuperSearchList
                                                type="client"
                                                id='State'
                                                name='State'
                                                searchValue={patientFormData.State}
                                                data={States}
                                                onChange={handleChangeDD}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                icon={'Simple'}
                                                sup_btn='sup_btn'
                                                sup_inp='superSearchVisitInp'
                                                className={validationErrors.State ? 'is-invalid' : ''}
                                            />
                                            {validationErrors.State && <div className="invalid-feedback">{validationErrors.State}</div>}
                                        </div>
                                    </div>
                                </div>

                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] flex items-center justify-end gap-0.5'>
                                        Cell Phone
                                    </p>
                                    <div className='input w-full'>
                                        <input type="text"
                                            className={`form-control ${validationErrors.CellPhone ? 'is-invalid' : ''}`}
                                            name="CellPhone"
                                            id="CellPhone"
                                            autoComplete="off"
                                            onChange={handleChangeField}
                                            value={patientFormData.CellPhone || ''}
                                            placeholder="(555) 555-5555"
                                            onKeyPress={(event) => handleNumericCheck(event)}
                                        />
                                        {validationErrors.CellPhone && <div className="invalid-feedback">{validationErrors.CellPhone}</div>}
                                    </div>
                                </div>
                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] text-end'>Home Phone</p>
                                    <div className='input w-full'>
                                        <input type="text"
                                            className={`form-control ${validationErrors.HomePhone ? 'is-invalid' : ''}`}
                                            name="HomePhone"
                                            id="HomePhone"
                                            autoComplete="off"
                                            onChange={handleChangeField}
                                            value={patientFormData.HomePhone || ''}
                                            placeholder="(555) 555-5555"
                                            onKeyPress={(event) => handleNumericCheck(event)}
                                        />
                                        {validationErrors.HomePhone && <div className="invalid-feedback">{validationErrors.HomePhone}</div>}
                                    </div>
                                </div>
                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] text-end'>Work Phone</p>
                                    <div className='input w-full'>
                                        <input type="text"
                                            className={`form-control ${validationErrors.WorkPhone ? 'is-invalid' : ''}`}
                                            name="WorkPhone"
                                            id="WorkPhone"
                                            autoComplete="off"
                                            onChange={handleChangeField}
                                            value={patientFormData.WorkPhone || ''}
                                            placeholder="(555) 555-5555"
                                            onKeyPress={(event) => handleNumericCheck(event)}
                                        />
                                        {validationErrors.WorkPhone && <div className="invalid-feedback">{validationErrors.WorkPhone}</div>}
                                    </div>
                                </div>
                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] text-end'>Other Phone</p>
                                    <div className='input w-full'>
                                        <input type="text"
                                            className={`form-control ${validationErrors.OtherPhone ? 'is-invalid' : ''}`}
                                            name="OtherPhone"
                                            id="OtherPhone"
                                            autoComplete="off"
                                            onChange={handleChangeField}
                                            value={patientFormData.OtherPhone || ''}
                                            placeholder="(555) 555-5555"
                                            onKeyPress={(event) => handleNumericCheck(event)}
                                        />
                                        {validationErrors.OtherPhone && <div className="invalid-feedback">{validationErrors.OtherPhone}</div>}
                                    </div>
                                </div>

                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] flex items-center justify-end gap-0.5'>
                                        Sex<span className="text font-m Denied-clr fs-14">*</span>
                                    </p>
                                    <div className='input w-full'>
                                        <SuperSearchList
                                            type="client"
                                            id='Sex'
                                            name='Sex'
                                            searchValue={patientFormData.Sex}
                                            data={GenderDemographic}
                                            onChange={handleChangeDD}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            icon={'Simple'}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                            className={validationErrors.Sex ? 'is-invalid' : ''}
                                        />
                                        {validationErrors.Sex && <div className="invalid-feedback">{validationErrors.Sex}</div>}
                                    </div>
                                </div>

                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] text-end'>Gender Identity</p>
                                    <div className='input w-full'>
                                        <SuperSearchList
                                            type="client"
                                            id='GenderIdentity'
                                            name='GenderIdentity'
                                            searchValue={patientFormData.GenderIdentity}
                                            data={GenderIdentity}
                                            onChange={handleChangeDD}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            icon={'Simple'}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>

                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] text-end'>Race</p>
                                    <div className='input w-full'>
                                        <SuperSearchList
                                            type="client"
                                            id='Race'
                                            name='Race'
                                            searchValue={patientFormData.Race}
                                            data={Races} 
                                            onChange={handleChangeDD}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            icon={'Simple'}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>

                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] text-end'>Ethnicity</p>
                                    <div className='input w-full'>
                                        <SuperSearchList
                                            type="client"
                                            id='Ethnicity'
                                            name='Ethnicity'
                                            searchValue={patientFormData.Ethnicity}
                                            data={Ethnicity} 
                                            onChange={handleChangeDD}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            icon={'Simple'}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>

                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] text-end'>Marital Status</p>
                                    <div className='input w-full'>
                                        <SuperSearchList
                                            type="client"
                                            id='MaritalStatus'
                                            name='MaritalStatus'
                                            searchValue={patientFormData.MaritalStatus}
                                            data={MaritalStatus}
                                            onChange={handleChangeDD}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            icon={'Simple'}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>

                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] text-end'>Employment Status</p>
                                    <div className='input w-full'>
                                        <SuperSearchList
                                            type="client"
                                            id='EmploymentStatus'
                                            name='EmploymentStatus'
                                            searchValue={patientFormData.EmploymentStatus}
                                            data={EmploymentStatus}
                                            onChange={handleChangeDD}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            icon={'Simple'}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>

                                <div className="flex gap-10 items-center">
                                    <p className='text fs-16 leading-5 min-w-[151px] text-end'>Preferred Language</p>
                                    <div className='input w-full'>
                                        <SuperSearchList
                                            type="client"
                                            id='PreferredLanguage'
                                            name='PreferredLanguage'
                                            searchValue={patientFormData.PreferredLanguage}
                                            data={PreferredLanguage}
                                            onChange={handleChangeDD}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            icon={'Simple'}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>
                                </div>
                                <div className="flex gap-2.5 items-center">
                                    <p className='text fs-14 text-black min-w-[156px] flex items-center justify-end gap-01'>
                                        OTP
                                        <span className="text font-m Denied-clr fs-14">*</span>
                                    </p>
                                    <div className='input w-full'>
                                        <input type="text"
                                            className={`form-control ${validationErrors.OTP ? 'is-invalid' : ''}`}
                                            name="OTP"
                                            id="OTP"
                                            autoComplete="off"
                                            onChange={handleChangeField}
                                            value={patientFormData.OTP || ''}
                                            onKeyPress={(event) => handleNumericCheck(event)}
                                        />
                                        {validationErrors.OTP && <div className="invalid-feedback">{validationErrors.OTP}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className='flex items-center gap-2 footer-btn br-top-1 br-clr-d8d8 pt-2'>
                                <button className='btn btn-orange fs-14 font-sb' onClick={handleSubmitForm}>Submit Form</button>
                                <button className='btn btn-outline dark-clr fs-14 font-sb' onClick={clearForm}>Clear Form</button>
                            </div>
                        </div>
                    </div> */}
                            <div className='ar_pat-info-form-fill d-flex justify-content-center'>
                                <div className="ar_fill-content-box d-flex flex-column gap-16">
                                    <div className="d-flex align-items-center justify-content-between bg-white br-bottom-1 za_br_light pb-1-5 practice-info">
                                        <div className="">
                                            <img src={LogoRef} alt="" style={{ maxHeight: '55px' }} crossOrigin="anonymous" />
                                        </div>
                                        <div className="text-center">
                                            <p className='heading text-black fs-16'>{PracticeInfo?.PracticeName}</p>

                                            <p className="text text-black fs-14"> {PracticeInfo?.PracticeAddress} <br />
                                                {PracticeInfo?.PracticeCity} ,  {PracticeInfo?.PracticeState},  {PracticeInfo?.PracticeZipCode}</p>

                                        </div>
                                        <div className="d-flex gap-10">
                                            <div className="">
                                                <p className='text text-black font-m fs-14 pb-2px'>Tel:</p>
                                                <p className='text text-black font-m fs-14'>Fax:</p>
                                            </div>
                                            <div className="">
                                                <p className='text text-black  pb-2px fs-14'>{FormatPhoneNumber(PracticeInfo?.PracticeTelephone)}</p>
                                                {/* <p className='text text-black fs-14'>{PracticeInfo?.PracticeFax}</p> */}
                                                <p className='text text-black fs-14'>{formatFax(PracticeInfo?.PracticeFax)}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="">
                                        <div className="bg-white">
                                            <p className="heading fs-16 lh-17 text-white form-heading">Patient Demographics</p>
                                            <p className="text fs-12 lh-14 form-instruction p-2">Please fill out all fields as accurately as possible. This information helps us provide you with the best care. If you need any assistance with completing this form, please don't hesitate to contact us.</p>
                                        </div>
                                        <div className="ar_star-form-Preview">
                                            <div className="Form-content d-flex flex-column gap-16 pe-1 hover-scrollbar Fill-demographics-form">
                                                <div className="d-flex flex-column gap-16 content-box pt-3">
                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px d-flex align-items-center justify-content-end gap-01'>
                                                            Name<span className="text font-m Denied-clr fs-14">*</span>
                                                        </p>
                                                        <div className="d-flex align-items-center gap-6">
                                                            <div className={`input ${validationErrors.LastName ? 'error' : ''}`}>
                                                                <input type="text"
                                                                    className={`form-control`}
                                                                    name="LastName"
                                                                    id="LastName"
                                                                    autoComplete="off"
                                                                    placeholder="Last"
                                                                    onChange={handleChangeField}
                                                                    value={patientFormData.LastName || ''}
                                                                    onKeyPress={handleAlphabeticCheck}
                                                                    maxLength={35}

                                                                />
                                                                {validationErrors.LastName &&
                                                                    <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                                                                        <i className="bi bi-info-circle-fill fs-10"></i>
                                                                        <p className="fs-9 text-white text">{validationErrors.LastName}</p>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className={`input ${validationErrors.FirstName ? 'error' : ''}`}>
                                                                <input type="text"
                                                                    className={`form-control`}
                                                                    name="FirstName"
                                                                    id="FirstName"
                                                                    autoComplete="off"
                                                                    placeholder="First"
                                                                    onChange={handleChangeField}
                                                                    value={patientFormData.FirstName || ''}
                                                                    onKeyPress={handleAlphabeticCheck}
                                                                    maxLength={35}

                                                                />
                                                                {validationErrors.FirstName &&
                                                                    <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                                                                        <i className="bi bi-info-circle-fill fs-10"></i>
                                                                        <p className="fs-9 text-white text">{validationErrors.FirstName}</p>
                                                                    </div>
                                                                }

                                                            </div>
                                                            <div className='input'>
                                                                <input type="text"
                                                                    className='form-control'
                                                                    name="MiddleName"
                                                                    id="MiddleName"
                                                                    autoComplete="off"
                                                                    placeholder="Middle"
                                                                    onChange={handleChangeField}
                                                                    value={patientFormData.MiddleName || ''}
                                                                    onKeyPress={handleAlphabeticCheck}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px text-end'>Preferred Name</p>
                                                        <div className='input w-100'>
                                                            <input type="text"
                                                                className='form-control'
                                                                name="PreferredName"
                                                                id="PreferredName"
                                                                autoComplete="off"
                                                                onChange={handleChangeField}
                                                                value={patientFormData.PreferredName || ''}
                                                                onKeyPress={handleAlphabeticCheck}
                                                                maxLength={35}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px d-flex align-items-center justify-content-end gap-01'>
                                                            SSN
                                                        </p>
                                                        <div className={`input w-100 ${validationErrors.SSN ? 'error' : ''}`}>
                                                            <input type="text"
                                                                className={`form-control `}
                                                                name="SSN"
                                                                id="SSN"
                                                                autoComplete="off"
                                                                onChange={handleChangeField}
                                                                value={patientFormData.SSN || ''}
                                                                onKeyPress={(event) => handleNumericCheck(event)}
                                                                maxLength={9}
                                                            />
                                                            {validationErrors.SSN &&
                                                                <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                                                                    <i className="bi bi-info-circle-fill fs-10"></i>
                                                                    <p className="fs-9 text-white text">{validationErrors.SSN}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px d-flex align-items-center justify-content-end gap-01'>
                                                            Date of Birth<span className="text font-m Denied-clr fs-14">*</span>
                                                        </p>
                                                        <div className={`input w-100 ${validationErrors.DOB ? 'error' : ''}`}>
                                                            <DatePicker
                                                                value={patientFormData.DOB}
                                                                handleCalendarChangefunc={date => handleCalendarChange(date, 'DOB')}
                                                                inputError={validationErrors.DOB}
                                                                showLabel={false}
                                                            />
                                                            {validationErrors.DOB &&
                                                                <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                                                                    <i className="bi bi-info-circle-fill fs-10"></i>
                                                                    <p className="fs-9 text-white text">{validationErrors.DOB}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px d-flex align-items-center justify-content-end gap-01'>
                                                            Address 1<span className="text font-m Denied-clr fs-14">*</span>
                                                        </p>
                                                        <div className={`input w-100 ${validationErrors.Address1 ? 'error' : ''}`}>
                                                            <input type="text"
                                                                className={`form-control`}
                                                                name="Address1"
                                                                id="Address1"
                                                                autoComplete="off"
                                                                onChange={handleChangeField}
                                                                value={patientFormData.Address1 || ''}
                                                            />
                                                            {validationErrors.Address1 &&
                                                                <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                                                                    <i className="bi bi-info-circle-fill fs-10"></i>
                                                                    <p className="fs-9 text-white text">{validationErrors.Address1}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px d-flex align-items-center justify-content-end gap-01'>
                                                            Address 2
                                                        </p>
                                                        <div className='input w-100'>
                                                            <input type="text"
                                                                className='form-control'
                                                                name="Address2"
                                                                id="Address2"
                                                                autoComplete="off"
                                                                onChange={handleChangeField}
                                                                value={patientFormData.Address2 || ''}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px d-flex align-items-center justify-content-end gap-01'>
                                                            ZIP Code<span className="text font-m Denied-clr fs-14">*</span>
                                                        </p>
                                                        <div className={`input w-100 ${validationErrors.ZipCode ? 'error' : ''}`}>
                                                            <input type="text"
                                                                className={`form-control`}
                                                                name="ZipCode"
                                                                id="ZipCode"
                                                                autoComplete="off"
                                                                onChange={handleChangeField}
                                                                onKeyPress={(event) => handleNumericCheck(event)}
                                                                value={patientFormData.ZipCode || ''}
                                                                maxLength={9}
                                                            />
                                                            {validationErrors.ZipCode &&
                                                                <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                                                                    <i className="bi bi-info-circle-fill fs-10"></i>
                                                                    <p className="fs-9 text-white text">{validationErrors.ZipCode}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px d-flex align-items-center justify-content-end gap-01'>
                                                            City/State<span className="text font-m Denied-clr fs-14">*</span>
                                                        </p>
                                                        <div className="d-flex align-items-cnter gap-6">
                                                            <div className={`input w-100 ${validationErrors.City ? 'error' : ''}`}>
                                                                <input type="text"
                                                                    className={`form-control`}
                                                                    name="City"
                                                                    id="City"
                                                                    autoComplete="off"
                                                                    placeholder="City"
                                                                    onChange={handleChangeField}
                                                                    value={patientFormData.City || ''}
                                                                    maxLength={30}
                                                                />
                                                                {validationErrors.City &&
                                                                    <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                                                                        <i className="bi bi-info-circle-fill fs-10"></i>
                                                                        <p className="fs-9 text-white text">{validationErrors.City}</p>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className={`input w-100 ${validationErrors.State ? 'error' : ''}`}>
                                                                <SuperSearchList
                                                                    type="client"
                                                                    id='State'
                                                                    name='State'
                                                                    searchValue={patientFormData.State}
                                                                    data={States}
                                                                    onChange={handleChangeDD}
                                                                    getSelectedData={handleSelectedData}
                                                                    is={is}
                                                                    icon={'Simple'}
                                                                    sup_btn='sup_btn'
                                                                    sup_inp='superSearchVisitInp'
                                                                    className={validationErrors.State ? 'is-invalid' : ''}
                                                                />
                                                                {validationErrors.State &&
                                                                    <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                                                                        <i className="bi bi-info-circle-fill fs-10"></i>
                                                                        <p className="fs-9 text-white text">{validationErrors.State}</p>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px d-flex align-items-center justify-content-end gap-01'>
                                                            Cell Phone
                                                        </p>
                                                        <div className={`input w-100 ${validationErrors.CellPhone ? 'error' : ''}`}>
                                                            <input type="text"
                                                                className={`form-control`}
                                                                name="CellPhone"
                                                                id="CellPhone"
                                                                autoComplete="off"
                                                                onChange={handleChangeField}
                                                                value={patientFormData.CellPhone || ''}
                                                                placeholder="(555) 555-5555"
                                                                onKeyPress={(event) => handleNumericCheck(event)}
                                                            />

                                                            {validationErrors.CellPhone &&
                                                                <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                                                                    <i className="bi bi-info-circle-fill fs-10"></i>
                                                                    <p className="fs-9 text-white text">{validationErrors.CellPhone}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px text-end'>Home Phone</p>
                                                        <div className={`input w-100 ${validationErrors.HomePhone ? 'error' : ''}`}>
                                                            <input type="text"
                                                                className={`form-control`}
                                                                name="HomePhone"
                                                                id="HomePhone"
                                                                autoComplete="off"
                                                                onChange={handleChangeField}
                                                                value={patientFormData.HomePhone || ''}
                                                                placeholder="(555) 555-5555"
                                                                onKeyPress={(event) => handleNumericCheck(event)}
                                                            />

                                                            {validationErrors.HomePhone &&
                                                                <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                                                                    <i className="bi bi-info-circle-fill fs-10"></i>
                                                                    <p className="fs-9 text-white text">{validationErrors.HomePhone}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px text-end'>Work Phone</p>
                                                        <div className={`input w-100 ${validationErrors.WorkPhone ? 'error' : ''}`}>
                                                            <input type="text"
                                                                className={`form-control`}
                                                                name="WorkPhone"
                                                                id="WorkPhone"
                                                                autoComplete="off"
                                                                onChange={handleChangeField}
                                                                value={patientFormData.WorkPhone || ''}
                                                                placeholder="(555) 555-5555"
                                                                onKeyPress={(event) => handleNumericCheck(event)}
                                                            />

                                                            {validationErrors.WorkPhone &&
                                                                <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                                                                    <i className="bi bi-info-circle-fill fs-10"></i>
                                                                    <p className="fs-9 text-white text">{validationErrors.WorkPhone}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px text-end'>Other Phone</p>
                                                        <div className={`input w-100 ${validationErrors.OtherPhone ? 'error' : ''}`}>
                                                            <input type="text"
                                                                className={`form-control`}
                                                                name="OtherPhone"
                                                                id="OtherPhone"
                                                                autoComplete="off"
                                                                onChange={handleChangeField}
                                                                value={patientFormData.OtherPhone || ''}
                                                                placeholder="(555) 555-5555"
                                                                onKeyPress={(event) => handleNumericCheck(event)}
                                                            />
                                                            {validationErrors.OtherPhone &&
                                                                <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                                                                    <i className="bi bi-info-circle-fill fs-10"></i>
                                                                    <p className="fs-9 text-white text">{validationErrors.OtherPhone}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px d-flex align-items-center justify-content-end gap-01'>
                                                            Sex<span className="text font-m Denied-clr fs-14">*</span>
                                                        </p>
                                                        <div className={`input w-100 ${validationErrors.Sex ? 'error' : ''}`}>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='Sex'
                                                                name='Sex'
                                                                searchValue={patientFormData.Sex}
                                                                data={GenderDemographic}
                                                                onChange={handleChangeDD}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            />

                                                            {validationErrors.Sex &&
                                                                <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                                                                    <i className="bi bi-info-circle-fill fs-10"></i>
                                                                    <p className="fs-9 text-white text">{validationErrors.Sex}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px text-end'>Gender Identity</p>
                                                        <div className='input w-100'>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='GenderIdentity'
                                                                name='GenderIdentity'
                                                                searchValue={patientFormData.GenderIdentity}
                                                                data={GenderIdentity}
                                                                onChange={handleChangeDD}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px text-end'>Race</p>
                                                        <div className='input w-100'>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='Race'
                                                                name='Race'
                                                                searchValue={patientFormData.Race}
                                                                data={Races}
                                                                onChange={handleChangeDD}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px text-end'>Ethnicity</p>
                                                        <div className='input w-100'>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='Ethnicity'
                                                                name='Ethnicity'
                                                                searchValue={patientFormData.Ethnicity}
                                                                data={Ethnicity}
                                                                onChange={handleChangeDD}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px text-end'>Marital Status</p>
                                                        <div className='input w-100'>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='MaritalStatus'
                                                                name='MaritalStatus'
                                                                searchValue={patientFormData.MaritalStatus}
                                                                data={MaritalStatus}
                                                                onChange={handleChangeDD}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px text-end'>Employment Status</p>
                                                        <div className='input w-100'>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='EmploymentStatus'
                                                                name='EmploymentStatus'
                                                                searchValue={patientFormData.EmploymentStatus}
                                                                data={EmploymentStatus}
                                                                onChange={handleChangeDD}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-150px text-end'>Preferred Language</p>
                                                        <div className='input w-100'>
                                                            <SuperSearchList
                                                                type="client"
                                                                id='PreferredLanguage'
                                                                name='PreferredLanguage'
                                                                searchValue={patientFormData.PreferredLanguage}
                                                                data={PreferredLanguage}
                                                                onChange={handleChangeDD}
                                                                getSelectedData={handleSelectedData}
                                                                is={is}
                                                                icon={'Simple'}
                                                                sup_btn='sup_btn-Inp'
                                                                sup_inp='superSearchVisitInp'
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="">
                                                    <div className='ar_OTP-section d-flex flex-column gap-10'>
                                                        <p className='Patient-Payment text fs-13 ar_text w-max-content'>We've sent a verification code to your email. Check the same email you used to open the intake form link.</p>
                                                        <div className='px-2  content-box'>
                                                            <p className='text font-m ar-light-color fs-13 pb-3px'>Enter OTP here</p>
                                                            <div className={`input mb-0 w-50 ${validationErrors.OTP ? 'error' : ''}`}>
                                                                <input
                                                                    type="text"
                                                                    className="form-control h-28 za_br_light"
                                                                    name="OTP"
                                                                    id="OTP"
                                                                    autoComplete="off"
                                                                    onChange={handleChangeField}
                                                                    value={patientFormData.OTP || ''}
                                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                                />

                                                                {validationErrors.OTP &&
                                                                    <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                                                                        <i className="bi bi-info-circle-fill fs-10"></i>
                                                                        <p className="fs-9 text-white text">{validationErrors.OTP}</p>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='d-flex justify-content-between align-items-center footer-btn px-10'>
                                                        <button className='btn btn-orange h-auto submit-btn fs-14 font-sb' onClick={handleSubmitForm}>Submit Form</button>
                                                        <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={clearForm} >Clear Form</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            }
        </>

    )
}

export default FillPatientDemographicsForm